export const GoogleMapsAPI = 'AIzaSyAqcHDYkBF2fWsI_FAEgNcN4vVUMVSuq0k';
